// @flow

export const SITE_NAME: string = 'theEMPLOYEEapp'
export const PDF_LICENSE_KEY: string = 'o2zmc5SLCqmwN62bhU8P'
